(function () {
    'use strict';
    var m = angular.module('profiles');
    m.factory('virusHashMetaInfoLogic', ["widgetPolling", "fileDao", function (widgetPolling, fileDao) {
        return function ($scope) {
            var id = widgetPolling.scope().id;
            // for copy to clipboard, it only works on modern browsers.
            var body = angular.element(window.document.body);
            var textarea = angular.element('<textarea/>');
            textarea.css({
                position: 'fixed',
                opacity: '0'
            });
            function copyToClipboard(self) {
                var className = '.btn-virus-hash-' + self.key;
                var hashElement = angular.element(className).closest('.virus-hash-meta-data').find('.virus-hash-meta-value span');
                var hashTxt = angular.element(hashElement[0]).text();
                textarea.val(hashTxt);
                body.append(textarea);
                textarea[0].select();
                try {
                    var successful = document.execCommand('copy');
                    if (!successful)
                        throw successful;
                } catch (err) {
                    window.prompt('Copy to clipboard: Ctrl+C, Enter', hashTxt);
                }
                textarea.remove();
            }
            function openVirusTotal(hashText) {
                var virusTotalLink = 'https://www.virustotal.com/#/search/' + hashText;
                window.open(virusTotalLink);
            }
            $scope.model.data = [];
            return fileDao.retrieve(id).then(function (response) {
                if (response.data) {
                    var hashTypes = [
                        'md5',
                        'sha1',
                        'sha256'
                    ];
                    _(hashTypes).each(function (hashType) {
                        if (response.data['av_file_hash_' + hashType]) {
                            $scope.model.data.push({
                                key: hashType,
                                value: response.data['av_file_hash_' + hashType],
                                buttons: [
                                    {
                                        label: 'Copy',
                                        'class': 'btn btn-blue btn-virus-hash btn-virus-hash-' + hashType,
                                        key: hashType,
                                        onClick: function () {
                                            copyToClipboard(this);
                                        }
                                    },
                                    {
                                        label: 'Search this hash in VirusTotal',
                                        'class': 'btn btn-blue btn-virus-hash search-virus-hash',
                                        onClick: function () {
                                            openVirusTotal(response.data['av_file_hash_' + hashType]);
                                        }
                                    }
                                ]
                            });
                        }
                    });
                }
            });
        };
    }]);
}());